// Back to Top button: appears after 10% scroll, scrolls to top on click. Uses the global Lenis
// instance when active, native smooth scroll otherwise.
export default function initBackToTop() {
  const button = document.querySelector('.back-to-top');
  if (!button) return;

  const VISIBLE_THRESHOLD = 0.1; // 10% of the scrollable page height
  let ticking = false;

  function scrollableHeight() {
    const doc = document.documentElement;
    return Math.max(doc.scrollHeight - window.innerHeight, 0);
  }

  function updateVisibility() {
    ticking = false;

    const max = scrollableHeight();
    const scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;
    const ratio = max > 0 ? scrolled / max : 0;

    button.classList.toggle('is-visible', ratio >= VISIBLE_THRESHOLD);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  // Lenis fires its own 'scroll' event (independent rAF loop); listen to it
  // too so visibility stays in sync when Lenis owns the scrolling.
  if (window.__kdLenis) {
    window.__kdLenis.on('scroll', requestUpdate);
  }

  button.addEventListener('click', () => {
    if (window.__kdLenis) {
      window.__kdLenis.scrollTo(0);
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  updateVisibility();
}
